export default {
  title: 'Welcome to\n gotin',
  defaultTitle: '有了gotin',
  experience: '',
  email: 'Email',
  password: 'Password',
  forgotPassword: 'Forgot password',
  started: 'Login',
  tips: 'By clicking "Login" or "Continue with LinkedIn", I accept the gotin Terms Of Service, Community Guidelines and have read the Privacy Policy.',
  register: 'Sign up ',
  newUser: 'New user?',
  or: 'Or',
  success: 'Login Successfully',
  failed: 'Login failed, please try again later',

  //
  welcomeTo: 'Welcome to',
  gsma2020: 'Gotin',
  inputEmailPop: 'Email',
  forgetPass: 'Forgot Password',
  login: 'Login',
  linkedinLogin: 'LinkedIn Login',
  newUser1: 'New user',
  registerNew: 'Register',
  registerRule:
    'By clicking "Login" or "Continue with LinkedIn", I accept the gotin Terms Of Service, Community Guidelines and have read the Privacy Policy.',
  inputEmail: 'Please enter your email',
  setPassPop: 'Please input password',
  emailValidationSuccess: 'Email verified',
  emailValidationFailure:
    'Email verification failed, please click on send again to receive another verification email',
  attention: 'Attention',
  confirm: 'OK',
  notValidateEmailYet:
    'We’ve sent an activation code to your email. (if you can’t find it, check your Spam).',
  wrongCredential: 'Password or email entered is wrong, please try again',
  pleaseLoginToViewContent: 'Please login to view this content',
  phoneRules: 'please enter a valid phone number',
  needCanUseEmail: 'Please provide a valid email address',
  loginRules: 'please enter a valid email address or phone number',
  signInwithVerificationCode: 'Sign in\nwith verification code',
  phoneNumber: 'Phone number',
  verificationCode: 'Verification code',
  enterEvent: 'Enter Event',
  phone: 'Phone',
  emails: 'Email',
  passwords: 'Password',
  forgetPassword: 'Forgot password',
  signInWithPassword: 'Sign in with password',
  enterYourEmail: 'Enter your email',
  signIn: 'Sign In',
  SignUp: 'Sign up now',
  continue: 'Continue',
  wrongSecurityCode: 'Wrong verification code',
  alreadyRegistered: 'Sign in',
  sendAgain: 'Send again',
  sendCode: 'Send code',
  sendCodePorsche: 'Send code',
  alreadyRegisteredBefore: 'Have an account? Log in',
  newSignup: 'Sign up',
  welcome: 'Welcome back!',
  welcomeNjcb: '欢迎进入“你好世界”，\n开启元宇宙探索之旅！',
  welcomePorsche: 'Welcome to Clubland',
  welcomePorscheHR: 'Welcome to Porscheopolis',
  welcomeNissan: '欢迎来到尽兴e家',
  welcomeAiahrn: '欢迎来到\n友邦易空间',
  welcomePorsche911: 'Welcome to',
  welcomeSubPorsche911: 'Porsche Dreamverse',
  titlePorsche911: 'Porsche Dreamverse',
  welcomeZl: '出发！职场多元宇宙',
  addPersonalInfo: 'Add your personal information',
  tokenSent: 'The verification code is sent successfully',
  zlzpLogin: 'Enter',
  porscheLogin: 'Enter',
  welcomePorschetaycan: 'Welcome to',
  welcomeSubPorschetaycan: 'Porsche Virtual Art Gallery',
  titlePorscheTaycan: 'Virtual Art Gallery',
  welcomeNjcbmeets: 'Welcome to Njcbmeets',
  welcomeTakedaspark: 'Welcome to',
  bindPhoneAgain:
    'The phone number has already been registered. Would you like to log in using the existing phone number?',
  yes: 'Yes',
  no: 'No',
}
